var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnsound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4123 4.92262C17.0102 5.17027 17.4 5.75369 17.4 6.40083V25.6008C17.4 26.248 17.0102 26.8313 16.4123 27.079C15.8144 27.3267 15.1262 27.1897 14.6686 26.7321L8.73726 20.8008H4.6C3.71635 20.8008 3 20.0845 3 19.2008V12.8008C3 11.9172 3.71635 11.2008 4.6 11.2008H8.73726L14.6686 5.26945C15.1262 4.81185 15.8144 4.67497 16.4123 4.92262Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3514 12.3348C21.9051 11.8884 21.1814 11.8884 20.7351 12.3348C20.2888 12.781 20.2888 13.5047 20.7351 13.951L22.7842 16L20.7351 18.049C20.2888 18.4953 20.2888 19.219 20.7351 19.6652C21.1814 20.1116 21.9051 20.1116 22.3514 19.6652L24.4004 17.6162L26.4494 19.6652C26.8957 20.1116 27.6194 20.1116 28.0656 19.6652C28.512 19.219 28.512 18.4953 28.0656 18.049L26.0166 16L28.0656 13.951C28.512 13.5047 28.512 12.781 28.0656 12.3348C27.6194 11.8884 26.8957 11.8884 26.4494 12.3348L24.4004 14.3838L22.3514 12.3348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnsound);
export default __webpack_public_path__ + "static/media/icon-unsound.3970046b39291886314e6e0e2e0232a8.svg";
export { ForwardRef as ReactComponent };